import React from "react";

export default function Story() {
  return (
    <section id="story">
      <div className="container mx-auto flex px-10 py-10 md:flex-row flex-col items-center">
        <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
          <h3 className="title-font sm:text-3xl text-3xl mb-4 font-medium text-white">
            Childhood
          </h3>
          <p className="mb-8 leading-relaxed text-lg text-gray-300 md:text-left md:leading-loose">
            I grew up in Tunisia playing professional Tennis - ranking number 1 in the country in 2008 and 2010 - and extremely passionate about gaming and immersive experiences. <br></br>
            I started coding from the age of 13, and ultimately decided to focus on that instead of Tennis. <br></br>
            Professional sports taught me the importance of hard work and discipline, and I took that with me during my life. <br></br>
            I graduated with highest distinction from high school at 16, the youngest student to graduate in the entire school, and moved to the Netherlands
            to study Computer Science and pursue my passion.
          </p>
        </div>
        <div className="lg:max-w-lg lg:w-full md:w-1/4">
          <figure className="flex flex-col items-center">
            <img
              className="object-cover object-center rounded"
              src="./tennis.png"
            />
            <figcaption className="text-sm text-gray-400 mt-2">Winning my first Tennis tournament - Tunisia, 2008</figcaption>
          </figure>
        </div>
      </div>
      <div className="container mx-auto flex px-10 py-20 md:flex-row flex-col items-center">
        <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
          <h3 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-white">
            University
          </h3>
          <p className="mb-8 leading-relaxed text-lg text-gray-300 md:text-left md:leading-loose">
            During my undergrad in the Netherlands, I spent a lot of my free time building 2D/3D games and traveling around Europe to participate in hackathons. <br></br>
            I also joined the Honors Program, a special program at my university for the top 5% of the students where
            I was leading a team building an autonomous drone. Our team won the award for the best project in 2018. <br></br> 
            I discovered Virtual Reality the first time in a research lab, which ultimately led me to focus on Machine Learning & Computer Vision for my graduate studies. <br></br> <br></br>
            I moved to Switzerland to study Computer Science at EPFL - a top 10 engineering school. During my time there, I was a teaching assistant for the Machine Learning class
            and won an award for the best Data Visualization project in which we were selected to present at Stanford University in California. <br></br>
            Halfway through my Master's, I received an offer to join Revolut as a Data Scientist intern, the first ever intern of the company.
          </p>
          <div className="flex justify-center">
          <a
              href="https://apps.apple.com/us/app/shapion/id6471966052"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex text-white bg-green-500 border-0 py-2 px-6 focus:outline-none hover:bg-green-600 rounded text-lg">
              Shapion
            </a>
            <a
              href="https://studiegids.tue.nl/opleidingen/tue-honors-academy/bachelor-students/honors-tracks/high-tech-systems"
              target="_blank"
              rel="noopener noreferrer"
              className="ml-4 inline-flex text-gray-400 bg-gray-800 border-0 py-2 px-6 focus:outline-none hover:bg-gray-700 hover:text-white rounded text-lg">
              Honors Program
            </a>
          </div>
        </div>
        <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
        <figure className="flex flex-col items-center">
            <img
              className="object-cover object-center rounded"
              src="./natcap2.png"
            />
            <figcaption className="text-sm text-gray-400 mt-2">Presenting our Data Visualization project at Stanford University (California), 2019</figcaption>
          </figure>
        </div>
      </div>
      <div className="container mx-auto flex px-10 py-20 md:flex-row flex-col items-center">
        <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
          <h3 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-white">
            Career
          </h3>
          <p className="mb-8 leading-relaxed text-lg text-gray-300 md:text-left md:leading-loose">
            I moved to London and joined the Machine Learning & Computer Vision team at Revolut at age 20. During my internship, I built and productionized a feature that was used by 1500 people every day which protected people from fradusters accessing their account using face recognition. 
            Thanks to this project and many others, I was offered a full-time position and ended up dropping out from Master's to stay and continue growing the team. I played a key role in building and scaling the onboarding product using machine learning, which quickly became integral to the company's growth, serving around 30,000 new users every day.  <br></br> <br></br>
            Two years later, I joined Heron Data (YC S20) as a Founding Engineer and the second employee of the company. I worked extremely closely with the founders and grew the company 15x in revenue and 3x in team size. My role started by focusing on Machine Learning but quickly grew my responsibilities to do anything that creates value for the company. 
            This includeed product, customer success, machine learning, full-stack engineering, and sales. <br></br> 
            I had an incredible time there, but ultimately decided to try starting a company myself. <br></br> <br></br>
            I was selected to join Entrepreneur First, an intensive 3-month incubator in London to explore startup ideas. During my time there, I met incredible people and worked on exciting projects in the Augmented Reality & Virtual Reality space but could not find the right person to start a company with nor the right idea to pursue. <br></br> <br></br>
            I joined XYZ Reality as a Senior Machine Learning Engineer and the first AI hire of the company where I currently work. At XYZ Reality, we are building augmented reality headsets to accelerate construction projects worldwide. My role is to build the AI team and create our entire AI infrastructure. I have been building and deploying AI models in our platform while defining the roadmap with our leadership team. <br></br> <br></br>
            In August 2024, I won a top prize at the XR Hackathon in London, competing against over 150 talented hackers. Our team created a mixed reality experience that allows users to learn sign language and apply it in an interactive chess game. I led the development of a custom machine learning model for the Meta Quest 3, enabling real-time sign language recognition, which was key to the user experience. <br></br> <br></br>
          </p>
          <div className="flex justify-center">
            <a
              href="https://www.welcometothejungle.com/en/articles/machine-learning-engineer"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex text-white bg-green-500 border-0 py-2 px-6 focus:outline-none hover:bg-green-600 rounded text-lg">
              Article
            </a>
            <a
              href="https://open.spotify.com/episode/4YUknpQtDblPkU4iMX3hZL?si=e4aa222cd6614441"
              target="_blank"
              rel="noopener noreferrer"
              className="ml-4 inline-flex text-gray-400 bg-gray-800 border-0 py-2 px-6 focus:outline-none hover:bg-gray-700 hover:text-white rounded text-lg">
              Podcast
            </a>
            <a
              href="https://www.joinef.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="ml-4 inline-flex text-gray-400 bg-gray-800 border-0 py-2 px-6 focus:outline-none hover:bg-gray-700 hover:text-white rounded text-lg">
              Entrepreneur First
            </a>
            <a
              href="https://www.xrhack.com/london"
              target="_blank"
              rel="noopener noreferrer"
              className="ml-4 inline-flex text-gray-400 bg-gray-800 border-0 py-2 px-6 focus:outline-none hover:bg-gray-700 hover:text-white rounded text-lg">
              XR Hack
            </a>
          </div>
        </div>
        <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
          <figure className="flex flex-col items-center">
            <img
              className="object-cover object-center rounded"
              src="./xrhack.jpeg"
            />
            <figcaption className="text-sm text-gray-400 mt-2">Our winning team at XR Hack 2024 ceremony - London, 2024</figcaption>
          </figure>
        </div>
      </div>
      <div className="container mx-auto flex px-10 py-20 md:flex-row flex-col items-center">
        <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
          <h3 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-white">
            Becoming a founder
          </h3>
          <p className="mb-8 leading-relaxed text-lg text-gray-300 md:text-left md:leading-loose">
            In November 2024, together with my excellent friend, we decided to pursue our dream and start a company together. <br></br>  <br></br>  Growing up in Tunisia and India, we experienced what it truly means to live on the other side of the digital divide. 
            While our friends and colleagues in Europe and America were consuming content in their native language, many Tunisians and Indians were locked out of the global conversation simply because they didn't speak English. 
            This wasn't just about missing out on the latest Netflix shows, it was about access to knowledge, experiences, opportunities, and the ability to participate in the global economy. <br></br> <br></br> 
            We decided to go after this problem: making content truly accessible worldwide using AI technology. We raised funding from Andreessen Horowitz (a16z) as part of their Speedrun program to pursue our vision and have been working on our product since.
          </p>
          <div className="flex justify-center">
          <a
              href="https://usenativ.com"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex text-white bg-green-500 border-0 py-2 px-6 focus:outline-none hover:bg-green-600 rounded text-lg">
              Nativ
            </a>
            <a
              href="https://a16z.com/games/speedrun/"
              target="_blank"
              rel="noopener noreferrer"
              className="ml-4 inline-flex text-gray-400 bg-gray-800 border-0 py-2 px-6 focus:outline-none hover:bg-gray-700 hover:text-white rounded text-lg">
              A16Z Speedrun
            </a>
          </div>
        </div>
        <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
          <figure className="flex flex-col items-center">
            <img
              className="object-cover object-center rounded"
              src="./nativ-team.jpg"
            />
            <figcaption className="text-sm text-gray-400 mt-2">Our team at the a16z Speedrun kickoff event - San Francisco, 2025</figcaption>
          </figure>
        </div>
      </div>
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/components/Story.js